import Signal from 'libs/signals';

const loaderSignal = Signal({
  isAppLoading: false,
  isContentLoading: false,
  message: '',
});

export default loaderSignal;
